import { useMutation } from '@tanstack/react-query';

import { TCustomAxiosError } from '@/services/api';
import {
  recoverContentCreatorApplicationPost,
  TRecoverContentCreatorApplicationBody,
} from '@/services/api/requests/contentCreatorApplications';

import useToast from '../useToast';

const useRecoverContentCreatorApplication = () => {
  const toast = useToast();

  const { isPending, mutate, mutateAsync } = useMutation<
    unknown,
    TCustomAxiosError,
    TRecoverContentCreatorApplicationBody
  >({
    mutationFn: async (data: TRecoverContentCreatorApplicationBody) => {
      return recoverContentCreatorApplicationPost(data);
    },
    onSuccess: () => {
      toast({
        status: 'success',
        title: 'Recovery email sent',
        description: 'Check your inbox for a new application link.',
      });
    },
    onError: (error) => {
      toast({
        status: 'error',
        title: 'Recovery failed',
        description: error?.errors?.[0]?.message || 'We could not send a new application link. Please try again.',
      });
    },
  });

  return { isPending, mutate, mutateAsync };
};

export default useRecoverContentCreatorApplication;
